import React from "react";
import Table from "../../../../components/Table";
import TitleButtons from "../../../../components/TitleButtons";
import { useVendasSuprimentos } from "./Saidas-comercialData";

const DiretoriaComercialSaidas: React.FC = () => {
  const headers = [
    "PV",
    "Tipo", // 👈 NOVO
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Custo Unitário",
    "Cliente",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useVendasSuprimentos();

  const columnWidths = [
    "60px", // OS
    "80px", // Tipo 👈 NOVO
    "70px", // Código
    "300px", // Nome
    "50px", // Quantidade
    "70px", // Custo
    "90px", // Técnico
    "90px", // Data
    "60px", // Hora
  ];

  return (
    <div>
      <TitleButtons
        title="Diretoria - Saídas Comercial"
        buttons={
          [
            //  {
            //  label: "Gerar Relatório",
            //  onClick: () => console.log("Relatório gerado"),
            //  variant: "secondary",
            //  },
          ]
        }
      />
      <Table headers={headers} rows={rows} columnWidths={columnWidths} />
    </div>
  );
};

export default DiretoriaComercialSaidas;
